export const genderOptions = [
	{ key: '', value: 'Prefer not to say' },
	{ key: 'male', value: 'Male' },
	{ key: 'female', value: 'Female' },
];
